import { createSelector } from 'reselect';

const selectMarketPlacePolicy = (state: any) => state.marketPlacePolicy;


export const selectCurrentItem = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.current);

export const selectMarketPlacePolicyListItems = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.list);
export const selectMarketPlacePolicyQueryByEntityItems = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.queryByEntityType);

export const selectItemById = (itemId: any) =>
    createSelector(selectMarketPlacePolicyListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectMarketPlacePolicyQueryItems = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.query);
export const selectMarketPlacePolicyCreatedItem = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.create);

export const selectMarketPlacePolicyUpdatedItem = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.update);

export const selectselectMarketPlacePolicyReadItem = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.read);

export const selectMarketPlacePolicyDeletedItem = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.delete);

export const selectMarketPlacePolicySearchedItems = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.search);

export const selectMarketPlacePolicyItemsCount = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.count);

export const selectMarketPlacePolicyItemsFilter = createSelector([selectMarketPlacePolicy], (marketPlacePolicy) => marketPlacePolicy.filter);
